module.exports = __webpack_public_path__ + "static/media/YF87_1.4bb3cd9e.jpg";